import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import { ReachButton } from '../ReachButton/ReachButton';
import { AccentedText } from '../AccentedText/AccentedText';
import { processLink } from '../../shared/processLink';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';

export const FourColumnColumn = ({ node }) => {
    let image =
        node.relationships?.field_icon_img?.relationships
            ?.field_image_dark_blue_line;

    if (image) {
        if (node.bg === `white`) {
            image =
                node.relationships?.field_icon_img?.relationships
                    ?.field_image_white_sticker;
        } else if (node.bg === `dark`) {
            image =
                node.relationships?.field_icon_img?.relationships
                    ?.field_image_dark_blue_sticker;
        }
    }

    const gImage = image ? getImage(image.localFile) : undefined;

    return (
        <ParentNodeProvider
            nodeName={node.field_heading}
            nodeType="Four_Column"
        >
            <div className="column">
                {node.field_heading && (
                    <h2 className="typestack-title-5">
                        <AccentedText>{node.field_heading}</AccentedText>
                    </h2>
                )}
                {node.field_content_text && (
                    <div
                        className="text"
                        dangerouslySetInnerHTML={{
                            __html: node.field_content_text?.value,
                        }}
                    ></div>
                )}
                {node.field_link_single && (
                    <div className="buttons">
                        <ReachButton
                            href={processLink(node.field_link_single?.uri)}
                            buttonStyle="borderless"
                            buttonIcon={{
                                icon: `ki-arrow-right`,
                                position: `right`,
                            }}
                        >
                            {node.field_link_single?.title}
                        </ReachButton>
                    </div>
                )}
                {gImage && (
                    <div className="img">
                        <GatsbyImage image={gImage} alt="" />
                    </div>
                )}
            </div>
        </ParentNodeProvider>
    );
};
